import React from 'react'

import './messages-split-layout-column.scss'

import cn from '../../../../commons/src/libs/class-names'

import {CommonProps, Overwrite} from '../../../../commons/src/types'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    children: React.ReactNode
    headline?: React.ReactNode
    borderLeft?: boolean
  }
>

const MessagesSplitLayoutColumn = ({
  className,
  children,
  headline,
  borderLeft = false,
  ...props
}: Props) => (
  <div {...props} className={cn('MessagesSplitLayoutColumn', {borderLeft}, className)}>
    {headline && <div className="MessagesSplitLayoutColumn__header">{headline}</div>}
    <div className="MessagesSplitLayoutColumn__content">{children}</div>
  </div>
)

export default MessagesSplitLayoutColumn
